import { fixThumbnailUrl } from "../../utils/thumbail";
import { decodeHTMLEntities } from "../../utils/url";

export function ResourceCard({
  name,
  description,
  thumbnail,
  isDisabled,
  className,
  onClick,
}) {
  return (
    <div
      className={`col-sm-2 col-6 ${className}`}
      style={{
        display: isDisabled ? "none" : "block",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {/* Gradient Border Wrapper */}
      <div
        style={{
          background: "linear-gradient(135deg, #22c55e, #06b6d4)", // green → cyan
          borderRadius: "17px",
          padding: "0px",
        }}
      >
        <div className="card card-height card-radius bg-white">
          <div className="card-img">
            <img
              src={fixThumbnailUrl(thumbnail)}
              className="card-thumbnail"
              alt={name || "resource"}
            />
          </div>

          <div className="text-center px-2 pt-2 pb-1">
            {/* Title */}
            <p
              dangerouslySetInnerHTML={{ __html: name }}
              title={decodeHTMLEntities(name)}
              className="mb-1 text-dark"
              style={{
                fontSize: "1.1rem",
                fontWeight: 600,
                lineHeight: "1.4",
              }}
            ></p>

            {/* Description */}
            {description ? (
              <p
                className="mb-2"
                style={{
                  display: "inline-block",
                  padding: "3px 12px",
                  borderRadius: "12px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  color: "#0f766e",
                  background: "#ecfdf5",
                  border: "1px solid #34d399",
                }}
              >
                {description}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
